// BFF: ● complexity_segmentation (the top bar's pill). The shell's other data is legacy.
export { default } from './PatientDetailV2'
export { default as PatientDetailTopBar } from './PatientDetailTopBar'
export { default as PersonDetail } from './PersonDetail'
// The context and its initial state are the seam tests inject through; the provider owns them
// in production. Remove both once this state moves off Redux.
export {
  INITIAL_STATE as PATIENT_DETAIL_CONTEXT_INITIAL_STATE,
  PatientDetailContext,
  PatientDetailContextProvider,
} from './patientDetailContext'
export { usePatientDetail } from './usePatientDetail'
export { ExpandedModeControls } from './useExpandedMode'
